import { RailwayAlertTwoTone } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import type React from "react";

// TODO extend to all codes

interface FetchingErrorComponentProps {
	/**
	 * Error status code to determine correct message and icon
	 * e.g. 404 or 500
	 */
	statusCode: number;
	/**
	 * any custom ReactNode
	 * e.g. retry button/redirect button/copy error message etc.
	 */
	customComponent?: React.ReactNode;
}

const getTitle = (code: FetchingErrorComponentProps["statusCode"]) => {
	switch (code) {
		default:
			return "Tohle jsme nenakolejili...";
	}
};

const getSubTitle = (code: FetchingErrorComponentProps["statusCode"]) => {
	switch (code) {
		case 500:
			return "chyba 500 (interní chyba serveru)";
		default:
			return;
	}
};

const getMessage = (code: FetchingErrorComponentProps["statusCode"]) => {
	switch (code) {
		default:
			return "Moc se omouváme za vzniklou nepříjemnost, zkuste to prosím znovu později.";
	}
};

const getIcon = (code: FetchingErrorComponentProps["statusCode"]) => {
	switch (code) {
		default:
			return <RailwayAlertTwoTone sx={{ fontSize: "inherit", marginRight: "-15%" }} />;
	}
};

const FetchingErrorComponent: React.FC<FetchingErrorComponentProps> = ({ customComponent, statusCode }) => {
	const icon = getIcon(statusCode);
	const title = getTitle(statusCode);
	const subTitle = getSubTitle(statusCode);
	const message = getMessage(statusCode);

	return (
		<Box gap="1em" width="100%" justifyContent="center" alignItems="center" display="flex" flexDirection="column">
			<Typography
				display="flex"
				alignItems="center"
				justifyContent="center"
				fontSize="15rem"
				color="error"
				component="span"
			>
				{icon}
			</Typography>
			<Typography variant="h1" color="error" component="h3">
				{title}
			</Typography>
			{subTitle && (
				<Typography variant="h2" color="error" component="h4">
					{subTitle}
				</Typography>
			)}
			<Typography variant="h3" color="textDisabled">
				{message}
			</Typography>
			{customComponent && customComponent}
		</Box>
	);
};

export default FetchingErrorComponent;
